var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.543 21.709a1.908 1.908 0 0 1-1.085 0c-2.538-.866-8.208-4.48-8.208-10.605 0-2.704 2.179-4.891 4.865-4.891 1.592 0 3.001.77 3.885 1.96a4.838 4.838 0 0 1 3.885-1.96c2.686 0 4.865 2.187 4.865 4.89 0 6.126-5.67 9.74-8.207 10.606Z",
    fill: "#fff",
    stroke: "#767676",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeart;